// extracted by mini-css-extract-plugin
export default {"ContentLink":"cezjBxjlb6UzJZwXyXa1"};